import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_TENSAI_API,
});

export default api;
